/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import { FaArrowRight } from 'react-icons/fa'
import Lottie from 'lottie-react'

import clockAnim from './Animations/clock.json'
import confirmedAnim from './Animations/confirmed.json'
import loadAnim from './Animations/loading.json'
import onHoldAnim from './Animations/onHold.json'
import pickPackAnim from './Animations/pickPack.json'
import toBeConsAnim from './Animations/toBeCons.json'

// Function to subtract working hours from the current date
function subtractSydneyWorkingHours(hours: number): Date {
  const current = new Date()
  let remaining = hours

  while (remaining > 0) {
    current.setHours(current.getHours() - 1) // subtract 1 hour at a time

    const sydneyTime = new Date(
      current.toLocaleString('en-US', { timeZone: 'Australia/Sydney' }),
    )
    const day = sydneyTime.getDay() // 0 = Sunday, 6 = Saturday

    if (day !== 0 && day !== 6) {
      remaining--
    }
  }

  return current
}

function formatDateSydney(date: Date): string {
  const sydneyDate = new Date(
    date.toLocaleString('en-US', { timeZone: 'Australia/Sydney' }),
  )

  const pad = (n: number) => String(n).padStart(2, '0')
  return `${sydneyDate.getFullYear()}-${pad(sydneyDate.getMonth() + 1)}-${pad(
    sydneyDate.getDate(),
  )} ${pad(sydneyDate.getHours())}:${pad(sydneyDate.getMinutes())}:${pad(
    sydneyDate.getSeconds(),
  )}`
}
function getTimeMap() {
  // Example Usage
  const now = new Date()
  const from24 = subtractSydneyWorkingHours(24)
  const from72 = subtractSydneyWorkingHours(72)

  const TimeMap: Record<string, { from: string; to: string }> = {
    '0 to 24 hrs': {
      from: formatDateSydney(from24),
      to: formatDateSydney(now),
    },
    '24 to 72 hrs': {
      from: formatDateSydney(from72),
      to: formatDateSydney(from24),
    },
    'More than 72 hrs': {
      from: '2025-01-01 00:00:00',
      to: formatDateSydney(from72),
    },
  }

  return TimeMap
}

const animationMap: Record<string, any> = {
  'Confirmed': confirmedAnim,
  'On hold': onHoldAnim,
  'Pick & Pack': pickPackAnim,
  'To be Cons.': toBeConsAnim,
}

const bgMap: Record<string, string> = {
  '0 to 24 hrs': 'bg-P-200 ',
  '24 to 72 hrs': 'bg-P-300',
  'More than 72 hrs': 'bg-P-400',
}
const statusMap: Record<string, any> = {
  'Confirmed': ['RECEIVED', 'CONFIRMED'],
  'On hold': ['FAILED', 'EXCEPTION', 'BACKORDER', 'ONHOLD'],
  'Pick & Pack': ['OPEN'],
  'To be Cons.': ['TOBECONSIGNED', 'PARTIAL-CONSIGNED'],
}

export interface OrderStatusType {
  label: string
  value: number
}

export interface AgeRanges {
  label: string
  total: number
  status: OrderStatusType[]
}
export interface OrderAgeingCardProps {
  ageRanges: AgeRanges[]
  isLoading?: boolean
  filterVariables?: any
}
export const OrderAgeingCard: React.FC<OrderAgeingCardProps> = ({
  isLoading,
  ageRanges,
  filterVariables,
}) => {
  return (
    <div className='bg-white rounded-xl shadow-md p-4 max-w-3xl w-full'>
      <h2 className='text-base font-semibold mb-2'>Order Ageing</h2>

      <div className='flex flex-col gap-4'>
        {ageRanges.map(({ label, total, status }, idx) => (
          <div
            key={idx}
            className='flex flex-col lg:flex-row items-center gap-3 w-full'>
            {/* Time Range Box */}
            <div
              onClick={() => {
                const timeMap = getTimeMap()
                const queryParams = new URLSearchParams({
                  orderTypes: (filterVariables?.orderTypes || []).join(','),
                  partnerCodes: (filterVariables?.partnerCodes || []).join(','),
                  orderStatus: [
                    'RECEIVED',
                    'CONFIRMED',
                    'FAILED',
                    'EXCEPTION',
                    'OPEN',
                    'ONHOLD',
                    'TOBECONSIGNED',
                    'PARTIAL-CONSIGNED',
                    'BACKORDER',
                  ].join(','),
                  fromDate: timeMap[label].from,
                  toDate: timeMap[label].to, // formats as YYYY-MM-DD
                })

                window.open(
                  `/customer-order/orders?${queryParams.toString()}`,
                  '_blank',
                )
              }}
              className={`flex items-center gap-2 px-4 py-3 rounded-lg w-full lg:w-44 ${bgMap[label]}  hover:bg-P-700 rounded-lg transition-colors duration-200'`}>
              <Lottie
                animationData={clockAnim}
                loop
                style={{ width: 30, height: 30 }}
              />
              <div>
                <p className='text-xs text-gray-700 font-medium'>{label}</p>
                <p className='text-lg text-gray-900 font-bold'>{total}</p>
              </div>
            </div>

            {/* Arrow */}
            <div className='text-P-500 text-xl font-bold hidden lg:block'>
              <FaArrowRight />
            </div>

            {/* Status Summary */}
            <div className='w-full'>
              <div className='grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3'>
                {status.map(({ label: statusLabel, value }) => (
                  <div
                    onClick={() => {
                      const timeMap = getTimeMap()
                      const queryParams = new URLSearchParams({
                        orderTypes: (filterVariables?.orderTypes || []).join(
                          ',',
                        ),
                        partnerCodes: (
                          filterVariables?.partnerCodes || []
                        ).join(','),
                        orderStatus: statusMap[statusLabel]?.join(',') || '',
                        fromDate: timeMap[label].from,
                        toDate: timeMap[label].to, // formats as YYYY-MM-DD
                      })

                      window.open(
                        `/customer-order/orders?${queryParams.toString()}`,
                        '_blank',
                      )
                    }}
                    key={label}
                    className={` p-2 text-center  hover:bg-P-300 rounded-lg transition-colors duration-200`}>
                    <div className='flex flex-col items-center justify-center'>
                      <Lottie
                        animationData={animationMap[statusLabel]}
                        loop
                        style={{ width: 26, height: 26 }}
                      />
                      <p className='mt-1 text-xs font-medium'>{statusLabel}</p>

                      {isLoading ? (
                        <Lottie
                          animationData={loadAnim}
                          loop
                          style={{ width: 100, height: 50 }}
                        />
                      ) : (
                        <p className='text-base font-bold'>{value}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
